import { render, staticRenderFns } from "./AlunnoNote.vue?vue&type=template&id=01f4bf53&scoped=true&"
import script from "./AlunnoNote.vue?vue&type=script&lang=ts&"
export * from "./AlunnoNote.vue?vue&type=script&lang=ts&"
import style0 from "./AlunnoNote.vue?vue&type=style&index=0&id=01f4bf53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f4bf53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
